import React from 'react';
import { useLocation } from 'react-router-dom';
import { getPricingContext } from '../../utils/pricingDisplay';
import PricingCatalog from '../Pricing/PricingCatalog';
import PricingDialog from '../Pricing/PricingDialog';
import usePricingCheckout from '../Pricing/usePricingCheckout';

export default function SubscriptionPopup({ isOpen, onClose, allowTutorialClose = false, onTutorialClick }) {
  const location = useLocation();
  const context = getPricingContext(location.pathname);
  const checkout = usePricingCheckout();
  return <PricingDialog isOpen={isOpen} onClose={onClose} canClose={!allowTutorialClose}
    tutorialAction={allowTutorialClose ? onTutorialClick : undefined}>
    <PricingCatalog key={context} defaultProduct={context} onSelectPlan={checkout.selectPlan}
      pendingPlan={checkout.pendingPlan} error={checkout.error} />
  </PricingDialog>;
}
